<template>
<BaseTemplate>
  <div class="base">
    <Title :jpn="t('登録情報')"></Title>
    <div class="link_area">
      <GrayBack class="gray_area">
        <div class="link" @click="goToChangeMember">{{ t('個人情報') }}</div>
        <img class="allow" src="img/menu_right.png" />
      </GrayBack>
      <!-- <GrayBack class="gray_area">
        <div class="link" @click="goToTransferPoint">Point transfer</div>
      </GrayBack> -->
      <GrayBack class="gray_area">
        <div class="link" @click="goToChangePassword">{{ t('パスワード変更') }}</div>
        <img class="allow" src="img/menu_right.png" />
      </GrayBack>
    </div>
    <div class="button_area">
      <SquareButton
        class="square-button"
        :text="t('戻る')"
        @handleSquareBtnClick="goToBack"
      />
    </div>
  </div>
</BaseTemplate>
</template>

<script>
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import Title from '@/components/molecules/Title02.vue';
import GrayBack from '@/components/molecules/GrayBack.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';
import t from '@/plugins/i18n';

export default {
  mixins: [t],

  components: {
    BaseTemplate,
    Title,
    GrayBack,
    SquareButton,
  },
  methods: {
    goToBack() {
      this.$router.push('./');
    },
    goToChangeMember() {
      this.$router.push('./change-member');
    },
    goToChangePassword() {
      this.$router.push('./change-password');
    },
    goToTransferPoint() {
      this.$router.push('./transfer-point');
    },
  },
};
</script>

<style lang="scss" scoped>
.base {
  padding-top: 30px;
  padding-bottom: 50px;
  max-width: 600px;
  margin: auto;
  .link_area {
    margin: 40px 0;
    .gray_area {
      display: flex;
      align-items: center;
      border-radius: 15px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.7);
      padding: 10px 20px;
      margin: 20px 0;
      text-align: center;
      transition: .4s;
      position: relative;
      cursor: pointer;
      .link {
        width: 100%;
        padding: 20px 0;
        font-weight: bold;
        position: absolute;
        transform: translateX(-50%);
        left: 50%;
        color: #555555;
      }
      .allow {
        width: 40px;
        height: 40px;
        margin-left: auto;
        transition: transform 0.4s ease-in-out;
      }
      &:hover {
        background-color: #d9d9d9;
        .allow {
        transform: translateX(10px);
        }
      }
    }
  }
  .button_area {
    display: flex;
    justify-content: center;
    align-items: center;
    .square-button {
      max-width: 200px;
      width: 100%;
    }
  }
}
@media screen and (max-width: $tabletWidth) {
  .base {
    .link_area {
      padding: 0 10px;
      .link {
        &:active {
          background-color: $black;
        }
      }
    }
  }
}
</style>
